// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/nps_survey.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/nps_survey.proto.
 */
export const file_api_proto_v1_nps_survey: GenFile = /*@__PURE__*/
  fileDesc("Ch1hcGlfcHJvdG8vdjEvbnBzX3N1cnZleS5wcm90bxIMYXBpX3Byb3RvLnYxIhwKGkdldFBlbmRpbmdOcHNTdXJ2ZXlSZXF1ZXN0Il0KG0dldFBlbmRpbmdOcHNTdXJ2ZXlSZXNwb25zZRIzCgZzdXJ2ZXkYASABKAsyHi5hcGlfcHJvdG8udjEuUGVuZGluZ05wc1N1cnZleUgAiAEBQgkKB19zdXJ2ZXkiQgoQUGVuZGluZ05wc1N1cnZleRIKCgJpZBgBIAEoBRIQCghzZWVkX2tleRgCIAEoCRIQCghxdWVzdGlvbhgDIAEoCSJMChhTdWJtaXROcHNSZXNwb25zZVJlcXVlc3QSEQoJc3VydmV5X2lkGAEgASgFEg0KBXNjb3JlGAIgASgFEg4KBnNjcmVlbhgDIAEoCSIbChlTdWJtaXROcHNSZXNwb25zZVJlc3BvbnNlQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw");

/**
 * @generated from message api_proto.v1.GetPendingNpsSurveyRequest
 */
export type GetPendingNpsSurveyRequest = Message<"api_proto.v1.GetPendingNpsSurveyRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetPendingNpsSurveyRequest.
 * Use `create(GetPendingNpsSurveyRequestSchema)` to create a new message.
 */
export const GetPendingNpsSurveyRequestSchema: GenMessage<GetPendingNpsSurveyRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_nps_survey, 0);

/**
 * いま答えるべき設問。期間内の設問が無い・このスタッフが回答済み・サポートアカウント、のどれかなら
 * surveyは未設定（画面は何も出さない）。判定はサーバーが行う（画面に期間や回答済みの記憶を持たせない）。
 *
 * @generated from message api_proto.v1.GetPendingNpsSurveyResponse
 */
export type GetPendingNpsSurveyResponse = Message<"api_proto.v1.GetPendingNpsSurveyResponse"> & {
  /**
   * @generated from field: optional api_proto.v1.PendingNpsSurvey survey = 1;
   */
  survey?: PendingNpsSurvey;
};

/**
 * Describes the message api_proto.v1.GetPendingNpsSurveyResponse.
 * Use `create(GetPendingNpsSurveyResponseSchema)` to create a new message.
 */
export const GetPendingNpsSurveyResponseSchema: GenMessage<GetPendingNpsSurveyResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_nps_survey, 1);

/**
 * @generated from message api_proto.v1.PendingNpsSurvey
 */
export type PendingNpsSurvey = Message<"api_proto.v1.PendingNpsSurvey"> & {
  /**
   * nps_surveys.id。SubmitNpsResponseに渡す
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * 設問の安定した識別子（例2026-11-nps）。画面が「閉じた」を記憶するキーに使う
   *
   * @generated from field: string seed_key = 2;
   */
  seedKey: string;

  /**
   * 設問文。画面はこの文をそのまま出す
   *
   * @generated from field: string question = 3;
   */
  question: string;
};

/**
 * Describes the message api_proto.v1.PendingNpsSurvey.
 * Use `create(PendingNpsSurveySchema)` to create a new message.
 */
export const PendingNpsSurveySchema: GenMessage<PendingNpsSurvey> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_nps_survey, 2);

/**
 * 回答を1件保存する。企業・スタッフは認証情報から。設問が期間外・存在しない・スコアが範囲外なら
 * invalid_argument。同じスタッフの回答が既にあれば（二重タップ）、何も書かずに成功を返す。
 *
 * @generated from message api_proto.v1.SubmitNpsResponseRequest
 */
export type SubmitNpsResponseRequest = Message<"api_proto.v1.SubmitNpsResponseRequest"> & {
  /**
   * PendingNpsSurvey.id
   *
   * @generated from field: int32 survey_id = 1;
   */
  surveyId: number;

  /**
   * 0〜10
   *
   * @generated from field: int32 score = 2;
   */
  score: number;

  /**
   * 答えた画面。企業画面のルート名（routeUtils/route.tsのname。英小文字・数字・ハイフン、64文字まで）
   *
   * @generated from field: string screen = 3;
   */
  screen: string;
};

/**
 * Describes the message api_proto.v1.SubmitNpsResponseRequest.
 * Use `create(SubmitNpsResponseRequestSchema)` to create a new message.
 */
export const SubmitNpsResponseRequestSchema: GenMessage<SubmitNpsResponseRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_nps_survey, 3);

/**
 * @generated from message api_proto.v1.SubmitNpsResponseResponse
 */
export type SubmitNpsResponseResponse = Message<"api_proto.v1.SubmitNpsResponseResponse"> & {
};

/**
 * Describes the message api_proto.v1.SubmitNpsResponseResponse.
 * Use `create(SubmitNpsResponseResponseSchema)` to create a new message.
 */
export const SubmitNpsResponseResponseSchema: GenMessage<SubmitNpsResponseResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_nps_survey, 4);

